exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flexContainer[data-v-dd1c36c8] {\n  display: flex;\n  justify-content: flex-end;\n}", ""]);

// exports
